import { waitForElementToExist } from '../utilities'
import { getAccessibilityInfo } from '../utils/get-book-info'

function hideCartPopup () {
  if (window.theme.settings.template !== 'cart') return
  const htmlDocument = document.querySelector('html')
  htmlDocument.style.setProperty('overflow', 'scroll', 'important')
}

async function addCartElements () {
  if (window.theme.settings.template !== 'cart') return

  const subTotalRow = document.querySelector('.cart__row:last-child')
  if (!subTotalRow) return

  // Disable checkout button
  const checkoutButton = document.querySelector('.btn.cart__checkout')
  if (!checkoutButton) return
  checkoutButton.disabled = true

  let content = '<div class="cart__mb-additional-copy">'
  const cartResponse = await window.theme.cart.getCart()
  if (!cartResponse) return

  const containsSubscriptionProduct = cartResponse.items.some(item => {
    return item.product_type === 'Subscription'
  })
  if (!containsSubscriptionProduct) {
    content += `
      <div>
        Get all the latest titles delivered straight to you each month with a book subscription! <a href='/pages/print-subscriptions' target='_blank'>Learn more.</a>
      </div>
    `
  }

  content += `
    <div>
      eBooks purchased with your Mills and Boon Account use an eBook file link provided by our fulfillment partner VitalSource and an e-reader called Bookshelf. Please read our <a href='/pages/guide-to-ebooks' target='_blank'>Guide to eBooks</a> before making your purchase.
    </div>
    <label>
      <input type='checkbox' id='cartTermsCheckbox'>
      I have read the <a href='/pages/guide-to-ebooks' target='_blank'>eBook guide</a>, <a href='/pages/terms-of-sale' target='_blank'>terms of sale</a>, and the <a href='/pages/privacy-policy' target='_blank'>Privacy Policy</a>
    </label>
    </div>
  `
  subTotalRow.insertAdjacentHTML('beforebegin', content)

  const termsCheckbox = document.getElementById('cartTermsCheckbox')
  termsCheckbox.addEventListener('change', () => {
    checkoutButton.disabled = !termsCheckbox.checked
  })
}

function showBuyButtonOnceRechargeLoaded () {
  if (window.theme.productData.type && window.theme.productData.type !== 'Subscription') return
  const buyButton = document.querySelector('.add-to-cart')
  buyButton.style.display = 'none'
  waitForElementToExist('.rc_container_wrapper').then(() => {
    buyButton.style.display = 'block'
  })
}

function modifyOrderEbooksSubtitle () {
  if (window.theme.settings.template !== 'customers/order') return
  const vitalsourceSubtitle = document.querySelector('.order-vitalsource-subtitle')
  if (!vitalsourceSubtitle) return
  vitalsourceSubtitle.innerHTML = `
    Click hyperlinked book titles directly below to add your eBooks to your VitalSource Bookshelf.  Need more help? Visit our <a href="/pages/faqs" target="_blank">FAQ page</a>
  `
}

async function ebookAvailabilityCheck () {
  if (window.theme.settings.template !== 'product.mandb') return
  try {
    const productForm = document.querySelector('.mandb-product-single-form')
    if (!productForm) return
    const buyButton = productForm.querySelector('input[value="Add to cart"]')
    if (!buyButton) return

    const item = window.theme.staticProductData
    if (!item) return
    const { isbn13, formats } = item
    if (!isbn13 || !formats || !formats.length) return

    const currentFormat = formats.find(format => format.isbn === isbn13)
    const ebookCodes = ['DG', 'EA', 'EB', 'EC', 'ED']

    // hide button if no format or code so cannot check availability
    if (
      !currentFormat ||
      !currentFormat.format ||
      !currentFormat.format.code
    ) {
      buyButton.style.display = 'none'
      return
    }

    // Show button and make no call if not an eBook
    if (!ebookCodes.includes(currentFormat.format.code)) return

    buyButton.style.display = 'none'

    const requestUrl = `https://add-to-cart.supadu.com/add-to-cart?isbn=${isbn13}&client=mills-and-boon-au&action=availability&response=json`
    const response = await fetch(requestUrl)
    const responseJSON = await response.json()
    const { show, error } = responseJSON

    if (!show || error) {
      buyButton.remove()
    } else {
      buyButton.style.display = 'block'
    }
  } catch (e) {
    console.error(e)
  }
}

function initializeAccessibilityModal () {
  if (window.theme.settings.template !== 'product.mandb') return

  const accessibilityModal = document.getElementById('AccessibilityModal')
  if (!accessibilityModal) return

  new window.theme.Modals('AccessibilityModal', 'accessibility-modal')

  const modalContent = getAccessibilityInfo(window.theme.staticProductData)
  if (!modalContent) return

  const contentDiv = accessibilityModal.querySelector('.modal__content')
  if (!contentDiv) return

  contentDiv.innerHTML = modalContent
}

function customFunctions () {
  hideCartPopup()
  addCartElements()
  modifyOrderEbooksSubtitle()
  showBuyButtonOnceRechargeLoaded()
  ebookAvailabilityCheck()
  initializeAccessibilityModal()
}

module.exports = { customFunctions }
